module.exports = __webpack_public_path__ + "fonts/Outfit-Bold.e28d1b40.ttf";